import {produce} from 'immer';
import {MIAMember} from '@ace-de/eua-entity-types';
import * as memberActionTypes from './memberActionTypes';

const initialState = {
    memberInfo: {},
};

const memberReducer = produce((draft, action) => {
    const {type, payload} = action;
    switch (type) {
        case memberActionTypes.STORE_MEMBER_INFO: {
            const {memberInfoDTO} = payload;
            draft.memberInfo = new MIAMember().fromDTO(memberInfoDTO);
            break;
        }
    }
}, initialState);

export default memberReducer;
